export default "__VITE_ASSET__Bhlb5inj__"